<template>
  <v-dialog v-model="dialogVisible" max-width="500px" persistent>
    <v-card>
      <!-- Header with title and close button -->
      <v-card-title class="headline d-flex justify-space-between align-center">
        <span>{{ validAction === 'activar' ? 'Activar' : 'Inactivar' }} Base de Marcación</span>
        <v-btn 
          icon 
          @click="cancelar"
          :disabled="loading"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <!-- Content with register count -->
      <v-card-text class="text-center py-8">
        <div v-if="loadingRecords" class="text-body-1">
          <v-progress-circular indeterminate color="#cc092f" class="mb-4"></v-progress-circular>
          <div>Calculando registros afectados...</div>
        </div>
        
        <div v-else-if="totalRecords !== null" class="text-h6">
          Se {{ validAction === 'activar' ? 'activarán' : 'inactivarán' }} {{ totalRecords.toLocaleString() }} registro{{ totalRecords !== 1 ? 's' : '' }}
        </div>
        
        <div v-else class="text-body-1">
          Procesando información...
        </div>
      </v-card-text>
      
      <!-- Centered confirmation button -->
      <v-card-actions class="justify-center pb-6">
        <v-btn 
          color="#cc092f"
          dark
          rounded
          large
          @click="confirmar"
          :loading="loading"
          :disabled="loading || !fechaSeleccionada || totalRecords === null"
        >
          <v-icon left>
            {{ validAction === 'activar' ? 'mdi-check-circle' : 'mdi-close-circle' }}
          </v-icon>
          Confirmar {{ validAction === 'activar' ? 'Activación' : 'Inactivación' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DateRangeDialog',
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    accion: {
      type: String,
      default: 'activar',
      validator: value => {
        // Allow empty/null values (will use default) or valid actions
        return !value || ['activar', 'desactivar'].includes(value);
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    totalRecords: {
      type: Number,
      default: null
    },
    loadingRecords: {
      type: Boolean,
      default: false
    },
    initialDate: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      fechaSeleccionada: null,
      rules: {
        required: value => !!value || 'Este campo es requerido'
      }
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.cancelar();
        }
      }
    },
    
    // Ensure we always have a valid action
    validAction() {
      return this.accion && ['activar', 'desactivar'].includes(this.accion) ? this.accion : 'activar';
    }
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        this.initializeDates();
      }
    }
  },

  methods: {
    initializeDates() {
      // Use provided initial date or default to today
      if (this.initialDate) {
        this.fechaSeleccionada = this.initialDate;
      } else {
        const today = new Date().toISOString().split('T')[0];
        this.fechaSeleccionada = today;
      }
    },

    onDateChange() {
      // Emit date changes for real-time updates if needed
      this.$emit('date-change', {
        fechaInicio: this.fechaSeleccionada,
        fechaFin: this.fechaSeleccionada
      });
    },

    cancelar() {
      this.fechaSeleccionada = null;
      this.$emit('cancel');
    },

    confirmar() {
      if (!this.fechaSeleccionada) {
        return;
      }

      // API expects exactly 2 dates: [start, end]
      // For single day, send same date twice
      const fechas = [this.fechaSeleccionada, this.fechaSeleccionada];

      this.$emit('confirm', {
        fechas: fechas,
        fechaInicio: this.fechaSeleccionada,
        fechaFin: this.fechaSeleccionada
      });
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the date range dialog here */
</style>